import React, { useEffect, useRef, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  TextField,
  InputAdornment,
  Chip,
  Divider,
  TableContainer,
  useMediaQuery,
  useTheme,
  Collapse,
  CardActions,
  CardContent as MuiCardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox
} from "@material-ui/core/";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import GetAppIcon from "@material-ui/icons/GetApp";
import FilterListIcon from "@material-ui/icons/FilterList";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import AssignmentIcon from "@material-ui/icons/Assignment";
import DnerhsApi, { CancelToken } from "../../../api/DnerhsApi";
import { Link, useParams } from "react-router-dom";
import DeleteDialog from "../../../dialogs/DeleteDialog";
import history from "../../../utils/History";
import Alert from "../../../components/Alert";
import ResponseUtils from "../../../utils/ResponseUtils";
import useAuth from "../../../hooks/Auth";
import Roles from "../../../constants/Roles";
import EstadosCronograma from "../../../constants/EstadosCronograma";
import {Modal,Backdrop, TextareaAutosize } from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { eliminarMapHorarioStorage } from "services/UsuarioService";
import * as XLSX from "xlsx";


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#f8fafc',
    minHeight: '100vh',
  },
  title: {
    margin: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(),
  },
  modal: {
    position:'absolute',
    width: 800,
    backgroundColor: 'white',
    borderRadius: 12,
    borderColor: 'white',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    padding: theme.spacing(3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    focus:{
      outline: 'none'
    },
    outline: 'none'
  },
  // Header profesional
  headerContainer: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: 'white',
    borderRadius: theme.spacing(1),
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb',
  },
  headerContent: {
    position: 'relative',
    zIndex: 1,
  },
  // Buscador y filtros mejorados
  searchContainer: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: 'white',
    borderRadius: theme.spacing(1),
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e5e7eb',
  },
  searchField: {
    backgroundColor: '#f9fafb',
    borderRadius: theme.spacing(1),
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#d1d5db',
        borderWidth: 1,
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#3b82f6',
        borderWidth: 2,
      },
    },
    '& .MuiInputBase-input': {
      padding: theme.spacing(1.25),
    },
  },
  exportButton: {
    background: 'linear-gradient(45deg, #10b981 30%, #059669 90%)',
    color: 'white',
    fontWeight: 600,
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      background: 'linear-gradient(45deg, #059669 30%, #047857 90%)',
      transform: 'translateY(-1px)',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    },
    transition: 'all 0.2s ease-in-out',
  },
  // Tabla profesional
  tableContainer: {
    borderRadius: theme.spacing(2),
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    overflow: 'hidden',
    backgroundColor: 'white',
  },
  tableHeader: {
    background: 'linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%)',
    '& .MuiTableCell-head': {
      fontWeight: 700,
      color: '#1e293b',
      borderBottom: '2px solid #e2e8f0',
      fontSize: '0.875rem',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      padding: theme.spacing(2),
    },
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#f8fafc',
      transform: 'scale(1.001)',
      transition: 'all 0.2s ease-in-out',
    },
    '&:nth-of-type(even)': {
      backgroundColor: '#fafbfc',
    },
    borderBottom: '1px solid #f1f5f9',
  },
  tableCell: {
    padding: theme.spacing(1),
    borderBottom: '1px solid #f1f5f9',
  },
  bulkActionBar: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    border: '1px solid #e5e7eb',
    borderRadius: theme.spacing(1),
    backgroundColor: '#ffffff',
  },
  discreteButton: {
    textTransform: 'none',
    borderRadius: theme.spacing(1),
    fontWeight: 600,
  },
  filterChip: {
    borderRadius: theme.spacing(1),
    backgroundColor: '#f8fafc',
    border: '1px solid #e5e7eb',
    color: '#334155',
    fontWeight: 500,
  },
  topScroll: {
    overflowX: 'auto',
    overflowY: 'hidden',
    height: 16,
    borderBottom: '1px solid #f1f5f9',
    backgroundColor: '#ffffff',
  },
  // Paginación alineada a la derecha
  paginationRight: {
    '& .MuiTablePagination-toolbar': {
      justifyContent: 'flex-end',
      paddingRight: theme.spacing(2),
    },
    '& .MuiTablePagination-spacer': {
      flex: '1 1 100%',
    },
    '& .MuiTablePagination-actions': {
      marginLeft: theme.spacing(2),
    },
  },
  statusChip: {
    fontWeight: 600,
    fontSize: '0.75rem',
    borderRadius: theme.spacing(1),
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  actionButton: {
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
  },
  // Cards responsivas para móvil
  mobileCard: {
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(2),
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb',
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    },
  },
  mobileCardHeader: {
    background: 'linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%)',
    padding: theme.spacing(2),
    borderBottom: '1px solid #e5e7eb',
  },
  mobileCardContent: {
    padding: theme.spacing(2),
  },
  // Botón flotante mejorado
  fab: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    background: 'linear-gradient(45deg, #3b82f6 30%, #2563eb 90%)',
    color: 'white',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    '&:hover': {
      background: 'linear-gradient(45deg, #2563eb 30%, #1d4ed8 90%)',
      transform: 'scale(1.1)',
    },
    transition: 'all 0.2s ease-in-out',
  },
  // Estadísticas
  statsContainer: {
    marginBottom: theme.spacing(3),
  },
  statCard: {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    background: 'white',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb',
    textAlign: 'center',
  },
  statNumber: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#1e293b',
  },
  statLabel: {
    fontSize: '0.875rem',
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginTop: theme.spacing(0.5),
  },
}));

const List = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const tableScrollRef = useRef(null);
  const topScrollRef = useRef(null);

  // Estados principales
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalElements, setTotalElements] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [toDelete, setToDelete] = useState();
  const { hasRole, hasAnyRole } = useAuth();
  const params = useParams();
  const [observacion, setRechazoObservacion] = useState('');
  const [idFinalizar, setIdFinalizar] = useState();
  const [isPostgrado, setIsPostgrado] = useState(false);

  // Estados de búsqueda y filtros
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [estadoFilter, setEstadoFilter] = useState(''); // Filtro por estado
  const [rectificacionFilter, setRectificacionFilter] = useState(''); // Filtro por rectificación
  const [fechaDesdeFilter, setFechaDesdeFilter] = useState('');
  const [fechaHastaFilter, setFechaHastaFilter] = useState('');
  const [cronogramasRectificados, setCronogramasRectificados] = useState({}); // Mapa de cronogramaId -> cantidad de alumnos rectificados
  const [selectedCronogramas, setSelectedCronogramas] = useState([]);

  useEffect(() => {
    const load = () => {
      try {
        loadData(page, rowsPerPage);
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  // Efecto para manejar la búsqueda del lado del servidor con debounce
  useEffect(() => {
    // Limpiar timeout anterior
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Si no hay término de búsqueda, cargar datos normales
    if (!searchTerm.trim()) {
      setPage(0);
      loadData(0, rowsPerPage, '', estadoFilter, rectificacionFilter);
      return;
    }

    // Configurar nuevo timeout para búsqueda (debounce de 500ms)
    const timeout = setTimeout(() => {
      setPage(0);
      loadData(0, rowsPerPage, searchTerm.trim(), estadoFilter, rectificacionFilter);
    }, 500);

    setSearchTimeout(timeout);

    // Cleanup
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [searchTerm]);

  // Efecto para manejar cambio de filtro de estado
  useEffect(() => {
    setPage(0);
    loadData(0, rowsPerPage, searchTerm.trim(), estadoFilter, rectificacionFilter);
  }, [estadoFilter]);

  // Efecto para manejar cambio de filtro de rectificación
  useEffect(() => {
    setPage(0);
    loadData(0, rowsPerPage, searchTerm.trim(), estadoFilter, rectificacionFilter);
  }, [rectificacionFilter]);

  // Los datos ya vienen filtrados desde loadData
  const displayedRows = rows;

  // El total de elementos viene del servidor
  const totalCount = totalElements;

  const formatDate = (value) => {
    if (!value) {
      return '-';
    }

    if (typeof value === 'string') {
      const isoDateMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoDateMatch) {
        return `${isoDateMatch[3]}/${isoDateMatch[2]}/${isoDateMatch[1]}`;
      }
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? '-' : date.toLocaleDateString('es-ES');
  };

  const parseDateValue = (value) => {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      const isoDateMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoDateMatch) {
        return new Date(Number(isoDateMatch[1]), Number(isoDateMatch[2]) - 1, Number(isoDateMatch[3]));
      }

      const localDateMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
      if (localDateMatch) {
        return new Date(Number(localDateMatch[3]), Number(localDateMatch[2]) - 1, Number(localDateMatch[1]));
      }
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };

  const matchesPeriod = (row, desde, hasta) => {
    const filterDesde = parseDateValue(desde);
    const filterHasta = parseDateValue(hasta);

    if (!filterDesde && !filterHasta) {
      return true;
    }

    const rowDesde = parseDateValue(row.fechaDesde);
    const rowHasta = parseDateValue(row.fechaHasta);

    if (!rowDesde || !rowHasta) {
      return false;
    }

    if (filterDesde && rowDesde < filterDesde) {
      return false;
    }

    if (filterHasta && rowHasta > filterHasta) {
      return false;
    }

    return true;
  };

  const getRectificadosCount = (row, rectificadosMap = cronogramasRectificados) =>
    rectificadosMap[row.id] || row.alumnosRectificados || 0;

  const getShortStatus = (estado) => {
    if (!estado) {
      return '-';
    }

    const normalized = estado.toLowerCase();
    if (normalized.includes('finalizada')) return 'Finalizada';
    if (normalized.includes('aprobada')) return 'Aprobada';
    if (normalized.includes('rechazada') || normalized.includes('correcciones')) return 'Correcciones';
    if (normalized.includes('pendiente')) return 'Pendiente';
    if (normalized.includes('proceso')) return 'En proceso';
    if (normalized.includes('creada')) return 'Creada';
    return estado;
  };

  const getRectificacionLabel = (value) => {
    if (value === 'con_rectificacion') return 'Sí';
    if (value === 'sin_rectificacion') return 'No';
    return '';
  };

  const applyFiltersToRows = (
    data,
    rectificadosMap = cronogramasRectificados,
    filters = {}
  ) => {
    const search = (filters.searchTerm ?? searchTerm).trim().toLowerCase();
    const estado = filters.estadoFilter ?? estadoFilter;
    const rectificacion = filters.rectificacionFilter ?? rectificacionFilter;
    const fechaDesde = filters.fechaDesdeFilter ?? fechaDesdeFilter;
    const fechaHasta = filters.fechaHastaFilter ?? fechaHastaFilter;

    return data.filter((row) => {
      const rectificados = getRectificadosCount(row, rectificadosMap);
      const searchable = [
        row.id,
        row.materia,
        row.carreraDescripcion,
        row.curso,
        row.semestre,
        row.tutorPrincipal,
        row.tutorCedula,
        row.estado,
        formatDate(row.fechaDesde),
        formatDate(row.fechaHasta),
      ].filter(Boolean).join(' ').toLowerCase();

      if (search && !searchable.includes(search)) {
        return false;
      }

      if (estado && row.estado !== estado) {
        return false;
      }

      if (rectificacion === 'con_rectificacion' && rectificados === 0) {
        return false;
      }

      if (rectificacion === 'sin_rectificacion' && rectificados > 0) {
        return false;
      }

      return matchesPeriod(row, fechaDesde, fechaHasta);
    });
  };

  const mapRowsToExcel = (data) => data.map(row => ({
    "Nro. Cronograma": row.id,
    "Fecha Desde": formatDate(row.fechaDesde),
    "Fecha Hasta": formatDate(row.fechaHasta),
    "Carrera": row.carreraDescripcion,
    "Materia": row.materia,
    "Curso": row.curso,
    "Semestre": row.semestre,
    "Cantidad Alumnos": row.cantidadAlumnos || 0,
    "Alumnos Rectificados": getRectificadosCount(row),
    "Fecha de Envío": formatDate(row.fechaEnvio),
    "Tutor": row.tutorPrincipal || '-',
    "C.I. Tutor": row.tutorCedula || '-',
    "Estado": row.estado
  }));

  const downloadRowsAsExcel = (data, fileName, emptyMessage) => {
    if (!data || data.length === 0) {
      Alert.show({ message: emptyMessage, type: "warning" });
      return;
    }

    const ws = XLSX.utils.json_to_sheet(mapRowsToExcel(data));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Cronogramas");
    XLSX.writeFile(wb, fileName);
  };

  const formatBoolean = (value) => (
    value === true || value === 'true' || value === 1 ? 'Si' : 'No'
  );

  const formatPersonName = (...parts) => {
    const name = parts.filter(Boolean).join(' ').trim();
    return name || '-';
  };

  const getCronogramaCarrera = (practica) => (
    practica?.convenioCarrera?.nombrePostgrado?.descripcion ||
    practica?.convenioCarrera?.carreraPrograma?.descripcion ||
    '-'
  );

  const getDayMark = (row, dayNumber, fieldName) => {
    const hasDay = row?.practicaDetalleHorarioList?.some(
      (horario) => `${horario.dia}` === `${dayNumber}`
    );

    return hasDay || row?.[fieldName] ? '✓' : 'X';
  };

  const getDayName = (dia) => {
    const days = {
      1: 'Lunes',
      2: 'Martes',
      3: 'Miercoles',
      4: 'Jueves',
      5: 'Viernes',
      6: 'Sabado',
      7: 'Domingo',
    };

    return days[dia] || '-';
  };

  const formatTime = (value) => {
    if (!value) {
      return '-';
    }

    const text = `${value}`;
    return text.length >= 5 ? text.substring(0, 5) : text;
  };

  const formatHorarios = (row) => {
    const horarios = row?.practicaDetalleHorarioList || [];
    if (horarios.length > 0) {
      return horarios
        .map((horario) => `${getDayName(horario.dia)} ${formatTime(horario.horarioDesde)} - ${formatTime(horario.horarioHasta)}`)
        .join(' | ');
    }

    if (row?.horarioDesde || row?.horarioHasta) {
      return `${formatTime(row.horarioDesde)} - ${formatTime(row.horarioHasta)}`;
    }

    return '-';
  };

  const appendJsonSheet = (workbook, rows, sheetName) => {
    const worksheet = XLSX.utils.json_to_sheet(rows.length ? rows : [{ Mensaje: 'Sin datos' }]);
    const headers = Object.keys(rows[0] || { Mensaje: 'Sin datos' });
    worksheet['!cols'] = headers.map((header) => ({ wch: Math.max(header.length + 4, 16) }));
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  };

  const fetchCronogramaDetalleCompleto = async (practicaId) => {
    const [practicaResponse, detallesResponse, observacionesResponse] = await Promise.all([
      DnerhsApi.get(`/convenios/practicas/${practicaId}`),
      DnerhsApi.get(`/practicas-detalles/${practicaId}/practicas-detalles`),
      DnerhsApi.get(`/practicas-observaciones/${practicaId}/observaciones`).catch(() => ({ data: [] })),
    ]);

    const detalles = detallesResponse.data || [];
    const detallesConHorarios = await Promise.all(detalles.map(async (detalle) => {
      try {
        const { data } = await DnerhsApi.get(`/practicas-detalles-horarios/${detalle.id}/horarios`);
        return {
          ...detalle,
          practicaDetalleHorarioList: data || [],
        };
      } catch (error) {
        return {
          ...detalle,
          practicaDetalleHorarioList: [],
        };
      }
    }));

    return {
      practica: practicaResponse.data,
      detalles: detallesConHorarios,
      observaciones: observacionesResponse.data || [],
    };
  };

  const buildCronogramaDetalleWorkbook = ({ practica, detalles, observaciones }) => {
    const resumen = [{
      "Nro. Cronograma": practica?.id || '-',
      "Estado": practica?.estado || '-',
      "Carrera": getCronogramaCarrera(practica),
      "Materia": practica?.materia || '-',
      "Curso": practica?.curso || '-',
      "Semestre": practica?.semestre || '-',
      "Fecha Desde": formatDate(practica?.fechaDesde),
      "Fecha Hasta": formatDate(practica?.fechaHasta),
      "Fecha Envio": formatDate(practica?.fechaEnvio),
      "Institucion": practica?.convenioCarrera?.convenio?.institucionFormadora?.institucion || '-',
      "Sede": practica?.convenioCarrera?.convenio?.institucionFormadora?.sede || '-',
      "Observacion Cronograma": practica?.observacion || '-',
      "Cantidad Alumnos": detalles.length,
      "Alumnos Rectificados": detalles.filter((row) => row.rectificado === true || row.rectificado === 'true' || row.rectificado === 1).length,
    }];

    const alumnos = detalles.map((row, index) => ({
      "Nro.": index + 1,
      "C.I. Alumno": row.convenioEstudiante?.estudiante?.cedulaIdentidad || '-',
      "Alumno": formatPersonName(
        row.convenioEstudiante?.estudiante?.nombres,
        row.convenioEstudiante?.estudiante?.apellidos
      ),
      "Nacionalidad": row.convenioEstudiante?.estudiante?.nacionalidad?.nombre || '-',
      "Sede": row.convenioEstudiante?.convenio?.institucionFormadora?.sede || '-',
      "Curso": row.convenioEstudiante?.curso || row.curso || '-',
      "Anio": row.convenioEstudiante?.anio || row.anio || '-',
      "Domingo": getDayMark(row, 7, 'domingo'),
      "Lunes": getDayMark(row, 1, 'lunes'),
      "Martes": getDayMark(row, 2, 'martes'),
      "Miercoles": getDayMark(row, 3, 'miercoles'),
      "Jueves": getDayMark(row, 4, 'jueves'),
      "Viernes": getDayMark(row, 5, 'viernes'),
      "Sabado": getDayMark(row, 6, 'sabado'),
      "Horario": formatHorarios(row),
      "Total Horas": row.totalHoras || 0,
      "C.I. Tutor": row.convenioTutor?.tutor?.cedulaIdentidad || '-',
      "Tutor": formatPersonName(
        row.convenioTutor?.tutor?.nombres,
        row.convenioTutor?.tutor?.apellidos
      ),
      "Registro Profesional Tutor": row.convenioTutor?.tutor?.numeroRegistroProfesionalVigente || '-',
      "Establecimiento": row.establecimiento?.nombreServicio?.nombre || '-',
      "Rectificado": formatBoolean(row.rectificado),
      "Fecha Desde Rectificado": formatDate(row.fechaDesdeRectificado),
      "Fecha Hasta Rectificado": formatDate(row.fechaHastaRectificado),
      "Observacion Rectificacion": row.observacionRectificado || '-',
    }));

    const rectificaciones = detalles
      .filter((row) => row.rectificado === true || row.rectificado === 'true' || row.rectificado === 1)
      .map((row, index) => ({
        "Nro.": index + 1,
        "C.I. Alumno": row.convenioEstudiante?.estudiante?.cedulaIdentidad || '-',
        "Alumno": formatPersonName(
          row.convenioEstudiante?.estudiante?.nombres,
          row.convenioEstudiante?.estudiante?.apellidos
        ),
        "Fecha Desde Rectificado": formatDate(row.fechaDesdeRectificado),
        "Fecha Hasta Rectificado": formatDate(row.fechaHastaRectificado),
        "Observacion Rectificacion": row.observacionRectificado || '-',
      }));

    const observacionesRows = (observaciones || []).map((row, index) => ({
      "Nro.": index + 1,
      "Fecha": formatDate(row.fechaObservacion || row.fechaCreacion || row.fecha),
      "Estado": row.estado || row.tipo || '-',
      "Usuario": row.usuarioCreacion?.username || row.usuarioCreacion?.nombre || row.usuario || '-',
      "Observacion": row.observacion || '-',
    }));

    const workbook = XLSX.utils.book_new();
    appendJsonSheet(workbook, resumen, "Resumen");
    appendJsonSheet(workbook, alumnos, "Alumnos");
    appendJsonSheet(workbook, rectificaciones, "Rectificaciones");
    appendJsonSheet(workbook, observacionesRows, "Observaciones");
    return workbook;
  };

  const buildCronogramasSeleccionadosWorkbook = (cronogramasDetalle) => {
    const resumen = cronogramasDetalle.map(({ practica, detalles }) => ({
      "Nro. Cronograma": practica?.id || '-',
      "Estado": practica?.estado || '-',
      "Carrera": getCronogramaCarrera(practica),
      "Materia": practica?.materia || '-',
      "Curso": practica?.curso || '-',
      "Semestre": practica?.semestre || '-',
      "Fecha Desde": formatDate(practica?.fechaDesde),
      "Fecha Hasta": formatDate(practica?.fechaHasta),
      "Fecha Envio": formatDate(practica?.fechaEnvio),
      "Institucion": practica?.convenioCarrera?.convenio?.institucionFormadora?.institucion || '-',
      "Sede": practica?.convenioCarrera?.convenio?.institucionFormadora?.sede || '-',
      "Observacion Cronograma": practica?.observacion || '-',
      "Cantidad Alumnos": detalles.length,
      "Alumnos Rectificados": detalles.filter((row) => row.rectificado === true || row.rectificado === 'true' || row.rectificado === 1).length,
    }));

    const alumnos = cronogramasDetalle.flatMap(({ practica, detalles }) =>
      detalles.map((row, index) => ({
        "Nro. Cronograma": practica?.id || '-',
        "Materia": practica?.materia || '-',
        "Nro. Alumno": index + 1,
        "C.I. Alumno": row.convenioEstudiante?.estudiante?.cedulaIdentidad || '-',
        "Alumno": formatPersonName(
          row.convenioEstudiante?.estudiante?.nombres,
          row.convenioEstudiante?.estudiante?.apellidos
        ),
        "Nacionalidad": row.convenioEstudiante?.estudiante?.nacionalidad?.nombre || '-',
        "Sede": row.convenioEstudiante?.convenio?.institucionFormadora?.sede || '-',
        "Curso": row.convenioEstudiante?.curso || row.curso || '-',
        "Anio": row.convenioEstudiante?.anio || row.anio || '-',
        "Domingo": getDayMark(row, 7, 'domingo'),
        "Lunes": getDayMark(row, 1, 'lunes'),
        "Martes": getDayMark(row, 2, 'martes'),
        "Miercoles": getDayMark(row, 3, 'miercoles'),
        "Jueves": getDayMark(row, 4, 'jueves'),
        "Viernes": getDayMark(row, 5, 'viernes'),
        "Sabado": getDayMark(row, 6, 'sabado'),
        "Horario": formatHorarios(row),
        "Total Horas": row.totalHoras || 0,
        "C.I. Tutor": row.convenioTutor?.tutor?.cedulaIdentidad || '-',
        "Tutor": formatPersonName(
          row.convenioTutor?.tutor?.nombres,
          row.convenioTutor?.tutor?.apellidos
        ),
        "Registro Profesional Tutor": row.convenioTutor?.tutor?.numeroRegistroProfesionalVigente || '-',
        "Establecimiento": row.establecimiento?.nombreServicio?.nombre || '-',
        "Rectificado": formatBoolean(row.rectificado),
        "Fecha Desde Rectificado": formatDate(row.fechaDesdeRectificado),
        "Fecha Hasta Rectificado": formatDate(row.fechaHastaRectificado),
        "Observacion Rectificacion": row.observacionRectificado || '-',
      }))
    );

    const rectificaciones = cronogramasDetalle.flatMap(({ practica, detalles }) =>
      detalles
        .filter((row) => row.rectificado === true || row.rectificado === 'true' || row.rectificado === 1)
        .map((row, index) => ({
          "Nro. Cronograma": practica?.id || '-',
          "Materia": practica?.materia || '-',
          "Nro.": index + 1,
          "C.I. Alumno": row.convenioEstudiante?.estudiante?.cedulaIdentidad || '-',
          "Alumno": formatPersonName(
            row.convenioEstudiante?.estudiante?.nombres,
            row.convenioEstudiante?.estudiante?.apellidos
          ),
          "Fecha Desde Rectificado": formatDate(row.fechaDesdeRectificado),
          "Fecha Hasta Rectificado": formatDate(row.fechaHastaRectificado),
          "Observacion Rectificacion": row.observacionRectificado || '-',
        }))
    );

    const observacionesRows = cronogramasDetalle.flatMap(({ practica, observaciones }) =>
      (observaciones || []).map((row, index) => ({
        "Nro. Cronograma": practica?.id || '-',
        "Materia": practica?.materia || '-',
        "Nro.": index + 1,
        "Fecha": formatDate(row.fechaObservacion || row.fechaCreacion || row.fecha),
        "Estado": row.estado || row.tipo || '-',
        "Usuario": row.usuarioCreacion?.username || row.usuarioCreacion?.nombre || row.usuario || '-',
        "Observacion": row.observacion || '-',
      }))
    );

    const workbook = XLSX.utils.book_new();
    appendJsonSheet(workbook, resumen, "Resumen");
    appendJsonSheet(workbook, alumnos, "Alumnos");
    appendJsonSheet(workbook, rectificaciones, "Rectificaciones");
    appendJsonSheet(workbook, observacionesRows, "Observaciones");
    return workbook;
  };

  // Función para limpiar la búsqueda
  const handleClearSearch = () => {
    setSearchTerm('');
  };

  // Función para obtener colores según el estado
  const getStatusColor = (estado) => {
    const statusColors = {
      [EstadosCronograma.CREADA_PROCESO]: {
        bg: '#fef3c7',
        text: '#92400e',
        border: '#f59e0b'
      },
      [EstadosCronograma.PRACTICA_APROBADA]: {
        bg: '#d1fae5',
        text: '#065f46',
        border: '#10b981'
      },
      [EstadosCronograma.PRACTICA_RECHAZADA]: {
        bg: '#fee2e2',
        text: '#991b1b',
        border: '#ef4444'
      },
      [EstadosCronograma.PRACTICA_CRONOGRAMA_FINALIZADA]: {
        bg: '#e0e7ff',
        text: '#3730a3',
        border: '#6366f1'
      }
    };

    return statusColors[estado] || {
      bg: '#f3f4f6',
      text: '#374151',
      border: '#9ca3af'
    };
  };

  const loadData = async (
    page = 0,
    pageSize = 10,
    search = searchTerm,
    estado = estadoFilter,
    rectificacion = rectificacionFilter,
    fechaDesde = fechaDesdeFilter,
    fechaHasta = fechaHastaFilter
  ) => {
    setLoading(true);
    eliminarMapHorarioStorage();
    let source = CancelToken.source();
    try {
      const { data: convenioResponseData } = await DnerhsApi.get(`/convenios/${params.convenioId}`);
      if(convenioResponseData.categoria==="Postgrado"){
        setIsPostgrado(true);
      }

      const rectificadosMap = await loadRectificacionStats();
      const response = await DnerhsApi.get(
        `/convenios/${params.convenioId}/practicas-enhanced/export`,
        { cancelToken: source.token }
      );
      const filtered = applyFiltersToRows(response.data, rectificadosMap, {
        searchTerm: search,
        estadoFilter: estado,
        rectificacionFilter: rectificacion,
        fechaDesdeFilter: fechaDesde,
        fechaHastaFilter: fechaHasta,
      });
      const start = page * pageSize;

      setRows(filtered.slice(start, start + pageSize));
      setTotalElements(filtered.length);
      return;

      // Cargar estadísticas primero
      await loadRectificacionStats();

      // Si hay filtro de rectificación, cargar TODOS los cronogramas
      let url;
      let allData = [];

      if (rectificacion && rectificacion !== '') {
        // Cargar TODOS sin paginación
        url = `/convenios/${params.convenioId}/practicas-enhanced/export`;
        const params_export = [];
        if (search && search.trim()) {
          params_export.push(`search=${encodeURIComponent(search.trim())}`);
        }
        if (estado && estado.trim()) {
          params_export.push(`estado=${encodeURIComponent(estado.trim())}`);
        }
        if (params_export.length > 0) {
          url += `?${params_export.join('&')}`;
        }

        console.log('Loading ALL data from:', url);
        const response = await DnerhsApi(url, { cancelToken: source.token });
        allData = response.data; // Array directo

        // Filtrar por rectificación
        const filtered = allData.filter(row => {
          const cantidad = cronogramasRectificados[row.id] || 0;
          if (rectificacion === 'con_rectificacion') {
            return cantidad > 0;
          } else if (rectificacion === 'sin_rectificacion') {
            return cantidad === 0;
          }
          return true;
        });

        console.log(`📊 Filtrados: ${filtered.length} de ${allData.length}`);
        setRows(filtered);
        setTotalElements(filtered.length);
      } else {
        // Paginación normal
        url = `/convenios/${params.convenioId}/practicas-enhanced/?page=${page}&pageSize=${pageSize}`;
        if (search && search.trim()) {
          url += `&search=${encodeURIComponent(search.trim())}`;
        }
        if (estado && estado.trim()) {
          url += `&estado=${encodeURIComponent(estado.trim())}`;
        }

        console.log('Loading paginated data from:', url);
        const response = await DnerhsApi(url, { cancelToken: source.token });
        const { content, totalElements } = response.data;
        setRows(content);
        setTotalElements(totalElements);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const loadRectificacionStats = async () => {
    try {
      const url = `/practicas-convenio/convenio/${params.convenioId}`;
      console.log('🔍 Cargando rectificaciones desde:', url);
      const { data } = await DnerhsApi.get(url);
      console.log('📦 Total registros recibidos:', data.length);

      // Contar registros con rectificado = true
      const conRectificacion = data.filter(row => row.rectificado === true);
      console.log(`✅ Registros con rectificado=true: ${conRectificacion.length}`);
      if (conRectificacion.length > 0) {
        console.log('📝 Primeros 3 con rectificación:', conRectificacion.slice(0, 3));
      }

      // Agrupar por cronogramaId y contar alumnos rectificados
      const rectificadosPorCronograma = {};

      data.forEach((row, index) => {
        if (!rectificadosPorCronograma[row.cronogramaId]) {
          rectificadosPorCronograma[row.cronogramaId] = 0;
        }

        if (row.rectificado === true || row.rectificado === 'true' || row.rectificado === 1) {
          rectificadosPorCronograma[row.cronogramaId]++;
          console.log(`✅ Rectificado encontrado en cronograma ${row.cronogramaId}: ${row.nombreApellido} (${row.cedulaIdentidad})`);
        }
      });

      // Filtrar solo los cronogramas que tienen rectificados
      const soloConRectificados = Object.entries(rectificadosPorCronograma)
        .filter(([id, cantidad]) => cantidad > 0)
        .reduce((acc, [id, cantidad]) => ({ ...acc, [id]: cantidad }), {});

      console.log('📊 Cronogramas CON rectificaciones:', soloConRectificados);
      console.log('📊 Total cronogramas con rectificaciones:', Object.keys(soloConRectificados).length);

      setCronogramasRectificados(rectificadosPorCronograma);
      return rectificadosPorCronograma;
    } catch (error) {
      console.log('❌ Error al cargar estadísticas de rectificación:', error);
      return {};
    }
  };

  const handleChangePage = async (event, newPage) => {
    setRows([]);
    try {
      setPage(newPage);
      await loadData(newPage, rowsPerPage, searchTerm.trim(), estadoFilter, rectificacionFilter, fechaDesdeFilter, fechaHastaFilter);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeRowsPerPage = async (event) => {
    let newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Resetear a la primera página

    setRows([]);
    try {
      await loadData(0, newRowsPerPage, searchTerm.trim(), estadoFilter, rectificacionFilter, fechaDesdeFilter, fechaHastaFilter);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteOne = async () => {
    let source = CancelToken.source();
    try {
      let url = `/convenios/practicas/${toDelete}`;
      await DnerhsApi.delete(url, {
        cancelToken: source.token,
      });

      Alert.show({ message: "Eliminado exitosamente.", type: "success" })

      await loadData({ page, rowsPerPage });

    } catch (error) {
      console.log(error);
      if (error.response) {
        showServerError(error);
      }
    }
    setOpenDialog(false);
    setToDelete();
  };

  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error"
    })
  }

  const handleOpenDialog = (id) => {
    setOpenDialog(true);
    setToDelete(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  
  const confirmOne = async () => {
    abrirCerrarModal();
    try {
      if (observacion == "") {
        Alert.show({
          message : "Por favor ingrese una observación",
          type : "error"
        });
        return;
      }

      await DnerhsApi.post(
        `/convenios/practicas/${idFinalizar}/finalizar-cronograma?observacion=${observacion}`
      );

      Alert.show({
        message: "Solicitud de revisión enviada exitosamente.",
        type: "success",
      });

     
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
       } 
    }
    history.goBack();
    setOpenDialog(false);

  };

  /*MODAL*/
  const [modal, setModal]=useState(false);
  const abrirCerrarModal =(id)=>{
    setModal(!modal);
    setIdFinalizar(id);
  }
    const cerrarModal =()=>{  
    setModal(!modal);    
  }
  const handleObservacionChange = ( value) => {
    //rechazoObservacion=value;
    setRechazoObservacion(value);
  };
  //  <Box sx={classes.box}>
  const bodyModal= (
    
    <div className={classes.modal} align="center" classes={{focused: classes.outlinedInputFocused}}>
        <Card>
        <CardContent>
          <div>
          <Typography align="center" variant="h5" color="primary">
          Observaciones Cronograma
              </Typography>
      
              <br/> <br/>
  
          </div>
          <br/> <br/>
          <TextareaAutosize aria-label="Observacion"  rows={6} rowsMax={10} style={{ width: 600 }} placeholder="Observaciones" onChange={(e) =>
                                  handleObservacionChange(e.target.value)}/>
          <br/> <br/>
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
        
           
            <Grid item className={classes.field}>
              <Button
                variant="contained"
                color="default"
                onClick={()=>cerrarModal()}>Cancelar
              </Button>
            </Grid>
            <Grid item className={classes.field}>
              <Button
                variant="contained"
                color="primary"
                onClick={confirmOne}
                >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
    
  )
 
  const showEditButton = (row) =>
    row.estado === EstadosCronograma.CREADA ||
    row.estado === EstadosCronograma.PRACTICA_RECHAZADA ||
    row.estado === EstadosCronograma.CREADA_PROCESO//, ||
   // row.estado === EstadosCronograma.PRACTICA_MODIFICACIONES_APROBADA
    ;

    const fetchFilteredRowsForExport = async () => {
      const rectificadosMap = await loadRectificacionStats();
      const response = await DnerhsApi.get(`/convenios/${params.convenioId}/practicas-enhanced/export`);
      return applyFiltersToRows(response.data, rectificadosMap);
    };

    const handleSearch = async () => {
      setPage(0);
      setSelectedCronogramas([]);
      await loadData(0, rowsPerPage, searchTerm.trim(), estadoFilter, rectificacionFilter, fechaDesdeFilter, fechaHastaFilter);
    };

    const handleClearFilters = async () => {
      setSearchTerm('');
      setEstadoFilter('');
      setRectificacionFilter('');
      setFechaDesdeFilter('');
      setFechaHastaFilter('');
      setSelectedCronogramas([]);
      setPage(0);
      await loadData(0, rowsPerPage, '', '', '', '', '');
    };

    const toggleRowSelection = (id) => {
      setSelectedCronogramas((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
      );
    };

    const toggleVisibleSelection = async () => {
      if (totalCount === 0) {
        return;
      }

      const allFilteredSelected = selectedCronogramas.length >= totalCount;

      if (allFilteredSelected) {
        setSelectedCronogramas([]);
        return;
      }

      try {
        setLoading(true);
        const dataToSelect = await fetchFilteredRowsForExport();
        setSelectedCronogramas(dataToSelect.map((row) => row.id));
      } catch (error) {
        console.error('Error al seleccionar cronogramas:', error);
        if (error.response) {
          showServerError(error);
        } else {
          Alert.show({
            message: "No se pudieron seleccionar todos los cronogramas.",
            type: "error"
          });
        }
      } finally {
        setLoading(false);
      }
    };

    const clearSelection = () => {
      setSelectedCronogramas([]);
    };

    const exportFilteredToExcel = async () => {
      try {
        setLoading(true);
        const dataToExport = await fetchFilteredRowsForExport();
        downloadRowsAsExcel(
          dataToExport,
          `Cronogramas_Filtrados_${new Date().toISOString().split('T')[0]}.xlsx`,
          "No hay cronogramas para exportar."
        );
      } catch (error) {
        console.error('Error al exportar:', error);
        if (error.response) {
          showServerError(error);
        }
      } finally {
        setLoading(false);
      }
    };

    const downloadSelected = async () => {
      if (selectedCronogramas.length === 0) {
        Alert.show({
          message: "Seleccione uno o más cronogramas para descargar.",
          type: "warning"
        });
        return;
      }

      try {
        setLoading(true);
        const dataToExport = await fetchFilteredRowsForExport();
        const selectedIds = selectedCronogramas.map((id) => `${id}`);
        const selectedRows = dataToExport.filter((row) => selectedIds.includes(`${row.id}`));
        if (selectedRows.length === 0) {
          Alert.show({
            message: "Seleccione uno o mÃ¡s cronogramas para descargar.",
            type: "warning"
          });
          return;
        }

        const cronogramasDetalle = await Promise.all(
          selectedRows.map((row) => fetchCronogramaDetalleCompleto(row.id))
        );
        const workbook = buildCronogramasSeleccionadosWorkbook(cronogramasDetalle);
        XLSX.writeFile(
          workbook,
          `Cronogramas_Seleccionados_Detalle_${new Date().toISOString().split('T')[0]}.xlsx`
        );
        if (false) {
        downloadRowsAsExcel(
          selectedRows,
          `Cronogramas_Seleccionados_${new Date().toISOString().split('T')[0]}.xlsx`,
          "Seleccione uno o más cronogramas para descargar."
        );
        }
      } catch (error) {
        console.error('Error al descargar seleccionados:', error);
        if (error.response) {
          showServerError(error);
        }
      } finally {
        setLoading(false);
      }
    };

    const downloadOne = async (row) => {
      try {
        setLoading(true);
        const cronogramaDetalle = await fetchCronogramaDetalleCompleto(row.id);
        const workbook = buildCronogramaDetalleWorkbook(cronogramaDetalle);
        XLSX.writeFile(
          workbook,
          `Cronograma_${row.id}_Detalle_${new Date().toISOString().split('T')[0]}.xlsx`
        );
      } catch (error) {
        console.error('Error al descargar detalle completo:', error);
        if (error.response) {
          showServerError(error);
        } else {
          Alert.show({
            message: "No se pudo descargar el detalle completo del cronograma.",
            type: "error"
          });
        }
      } finally {
        setLoading(false);
      }
    };

    const exportToExcel = async () => {
      try {
        setLoading(true);

        // Construir URL para exportación con filtros
        let url = `/convenios/${params.convenioId}/practicas-enhanced/export`;
        const params_export = [];
        if (searchTerm && searchTerm.trim()) {
          params_export.push(`search=${encodeURIComponent(searchTerm.trim())}`);
        }
        if (estadoFilter && estadoFilter.trim()) {
          params_export.push(`estado=${encodeURIComponent(estadoFilter.trim())}`);
        }
        if (params_export.length > 0) {
          url += `?${params_export.join('&')}`;
        }

        console.log('Exporting data from:', url);
        const response = await DnerhsApi.get(url);
        const dataToExport = response.data;

        const ws = XLSX.utils.json_to_sheet(dataToExport.map(row => ({
          "Nro. Cronograma": row.id,
          "Fecha Desde": formatDate(row.fechaDesde),
          "Fecha Hasta": formatDate(row.fechaHasta),
          "Carrera": row.carreraDescripcion,
          "Materia": row.materia,
          "Curso": row.curso,
          "Semestre": row.semestre,
          "Cantidad Alumnos": row.cantidadAlumnos || 0,
          "Alumnos Rectificados": cronogramasRectificados[row.id] || row.alumnosRectificados || 0,
          "Fecha de Envío": formatDate(row.fechaEnvio),
          "Tutor": row.tutorPrincipal || '-',
          "C.I. Tutor": row.tutorCedula || '-',
          "Estado": row.estado
        })));

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Cronogramas");
        const fileName = searchTerm.trim() ?
          `Cronogramas_Filtrados_${new Date().toISOString().split('T')[0]}.xlsx` :
          `Cronogramas_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(wb, fileName);

        console.log(`Exportados ${dataToExport.length} registros a Excel`);
      } catch (error) {
        console.error('Error al exportar:', error);
        if (error.response) {
          showServerError(error);
        }
      } finally {
        setLoading(false);
      }
    };

  return (
    <Grid container spacing={4}>
      
      <Grid item xs={12}>
        {/* Header con título y botón de exportar */}
        <Paper className={classes.headerContainer}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h5" color="primary" style={{ fontWeight: 600 }}>
                Cronogramas de Prácticas
              </Typography>
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
                Gestión y seguimiento de cronogramas de prácticas profesionales
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* Buscador y Filtros */}
        <Paper className={classes.searchContainer}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Buscar N° Cronograma, Materia, Carrera o Tutor"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={classes.searchField}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                  endAdornment: searchTerm && (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClearSearch}
                        size="small"
                        style={{ padding: 4 }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth variant="outlined" className={classes.searchField} size="small">
                <InputLabel>Estado</InputLabel>
                <Select
                  value={estadoFilter}
                  onChange={(e) => setEstadoFilter(e.target.value)}
                  label="Estado"
                >
                  <MenuItem value="">
                    <em>Todos</em>
                  </MenuItem>
                  {Object.entries(EstadosCronograma).map(([key, value]) => (
                    <MenuItem key={key} value={value}>
                      {getShortStatus(value)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl fullWidth variant="outlined" className={classes.searchField} size="small">
                <InputLabel>Rectificación</InputLabel>
                <Select
                  value={rectificacionFilter}
                  onChange={(e) => setRectificacionFilter(e.target.value)}
                  label="Rectificación"
                >
                  <MenuItem value="">
                    <em>Todos</em>
                  </MenuItem>
                  <MenuItem value="con_rectificacion">Con rectificación</MenuItem>
                  <MenuItem value="sin_rectificacion">Sin rectificación</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2} style={{ minWidth: 140 }}>
              <TextField
                fullWidth
                type="date"
                label="📅 Desde"
                variant="outlined"
                size="small"
                value={fechaDesdeFilter}
                onChange={(e) => setFechaDesdeFilter(e.target.value)}
                className={classes.searchField}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2} style={{ minWidth: 140 }}>
              <TextField
                fullWidth
                type="date"
                label="📅 Hasta"
                variant="outlined"
                size="small"
                value={fechaHastaFilter}
                onChange={(e) => setFechaHastaFilter(e.target.value)}
                className={classes.searchField}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6} md={1}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.discreteButton}
                onClick={handleSearch}
                size="medium"
              >
                Buscar
              </Button>
            </Grid>
            <Grid item xs={6} md={1}>
              <Button
                fullWidth
                variant="outlined"
                className={classes.discreteButton}
                onClick={handleClearFilters}
                size="medium"
              >
                Limpiar
              </Button>
            </Grid>
          </Grid>

          <Box display="flex" alignItems="center" flexWrap="wrap" mt={1.5} style={{ gap: 8 }}>
            {estadoFilter && (
              <Chip
                className={classes.filterChip}
                size="small"
                label={`Estado: ${getShortStatus(estadoFilter)}`}
                onDelete={() => setEstadoFilter('')}
              />
            )}
            {rectificacionFilter && (
              <Chip
                className={classes.filterChip}
                size="small"
                label={`Rectificación: ${getRectificacionLabel(rectificacionFilter)}`}
                onDelete={() => setRectificacionFilter('')}
              />
            )}
            {(fechaDesdeFilter || fechaHastaFilter) && (
              <Chip
                className={classes.filterChip}
                size="small"
                label={`Periodo: ${formatDate(fechaDesdeFilter) === '-' ? '...' : formatDate(fechaDesdeFilter)} - ${formatDate(fechaHastaFilter) === '-' ? '...' : formatDate(fechaHastaFilter)}`}
                onDelete={() => {
                  setFechaDesdeFilter('');
                  setFechaHastaFilter('');
                }}
              />
            )}
            {searchTerm.trim() && (
              <Chip
                className={classes.filterChip}
                size="small"
                label={`Búsqueda: ${searchTerm.trim()}`}
                onDelete={() => setSearchTerm('')}
              />
            )}
            <Typography variant="body2" color="textSecondary" style={{ marginLeft: 'auto' }}>
              Mostrando {displayedRows.length} de {totalElements} cronogramas
            </Typography>
          </Box>
        </Paper>

        {selectedCronogramas.length > 0 && (
          <Paper className={classes.bulkActionBar}>
            <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 12 }}>
              <Typography variant="body2" style={{ fontWeight: 700, color: '#334155' }}>
                ☑ {selectedCronogramas.length} cronogramas seleccionados
              </Typography>
              <Button
                variant="outlined"
                size="small"
                className={classes.discreteButton}
                startIcon={<GetAppIcon />}
                onClick={downloadSelected}
              >
                Descargar
              </Button>
              <Button
                variant="text"
                size="small"
                className={classes.discreteButton}
                onClick={clearSelection}
              >
                Limpiar
              </Button>
            </Box>
          </Paper>
        )}

        {isMobile && (
          <Box>
            {loading ? (
              <Paper className={classes.mobileCard}>
                <MuiCardContent>
                  <Typography variant="body2" color="textSecondary">Cargando datos...</Typography>
                </MuiCardContent>
              </Paper>
            ) : displayedRows.length === 0 ? (
              <Paper className={classes.mobileCard}>
                <MuiCardContent>
                  <Typography variant="body2" color="textSecondary">No hay cronogramas disponibles</Typography>
                </MuiCardContent>
              </Paper>
            ) : displayedRows.map((row) => (
              <Paper key={row.id} className={classes.mobileCard}>
                <Box className={classes.mobileCardHeader} display="flex" alignItems="center" justifyContent="space-between">
                  <Box display="flex" alignItems="center">
                    <Checkbox
                      size="small"
                      color="primary"
                      checked={selectedCronogramas.includes(row.id)}
                      onChange={() => toggleRowSelection(row.id)}
                    />
                    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                      #{row.id}
                    </Typography>
                  </Box>
                  <Tooltip title={row.estado || ''} arrow>
                    <Chip
                      size="small"
                      label={getShortStatus(row.estado)}
                      style={{
                        backgroundColor: getStatusColor(row.estado).bg,
                        color: getStatusColor(row.estado).text,
                        border: `1px solid ${getStatusColor(row.estado).border}`,
                        fontWeight: 600
                      }}
                    />
                  </Tooltip>
                </Box>
                <MuiCardContent className={classes.mobileCardContent}>
                  <Typography variant="body2" style={{ fontWeight: 600 }}>{row.carreraDescripcion}</Typography>
                  <Typography variant="body2" color="textSecondary">{row.materia}</Typography>
                  <Box display="flex" flexWrap="wrap" mt={1} style={{ gap: 6 }}>
                    <Chip size="small" label={`Desde ${formatDate(row.fechaDesde)}`} />
                    <Chip size="small" label={`Hasta ${formatDate(row.fechaHasta)}`} />
                    <Chip size="small" label={`Alumnos ${row.cantidadAlumnos || 0}`} />
                    <Chip size="small" label={`Rectif. ${getRectificadosCount(row)}`} />
                  </Box>
                  <Box display="flex" justifyContent="flex-end" mt={1} style={{ gap: 8 }}>
                    <Button
                      size="small"
                      variant="outlined"
                      className={classes.discreteButton}
                      onClick={() => history.push({
                        pathname: `/convenios/cronogramasPracticas/ver/${params.convenioId}/${row.id}`,
                        state: { readOnly: true }
                      })}
                    >
                      Ver
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      className={classes.discreteButton}
                      startIcon={<GetAppIcon />}
                      onClick={() => downloadOne(row)}
                    >
                      Descargar
                    </Button>
                  </Box>
                </MuiCardContent>
              </Paper>
            ))}
          </Box>
        )}

        {/* Tabla */}
        <Paper className={classes.tableContainer} style={{ display: isMobile ? 'none' : 'block' }}>
          <div
            ref={topScrollRef}
            className={classes.topScroll}
            onScroll={(event) => {
              if (tableScrollRef.current) {
                tableScrollRef.current.scrollLeft = event.currentTarget.scrollLeft;
              }
            }}
          >
            <div style={{ width: 1780, height: 1 }} />
          </div>
          <TableContainer
            ref={tableScrollRef}
            style={{ maxHeight: '70vh', overflowX: 'auto' }}
            onScroll={(event) => {
              if (topScrollRef.current) {
                topScrollRef.current.scrollLeft = event.currentTarget.scrollLeft;
              }
            }}
          >
            <Table size="small" stickyHeader style={{ minWidth: 1780 }}>
              <TableHead className={classes.tableHeader}>
                  <TableRow>
                  <TableCell padding="checkbox" style={{ fontWeight: 600, minWidth: 48, position: 'sticky', left: 0, zIndex: 5, backgroundColor: '#f8fafc' }}>
                    <Checkbox
                      size="small"
                      color="primary"
                      indeterminate={selectedCronogramas.length > 0 && selectedCronogramas.length < totalCount}
                      checked={totalCount > 0 && selectedCronogramas.length >= totalCount}
                      onChange={toggleVisibleSelection}
                    />
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 600, minWidth: 140, position: 'sticky', left: 48, zIndex: 5, backgroundColor: '#f8fafc' }}>Acciones</TableCell>
                  <TableCell align="left" style={{ fontWeight: 600, minWidth: 120, position: 'sticky', left: 188, zIndex: 5, backgroundColor: '#f8fafc' }}>Nro.</TableCell>
                  <TableCell align="left" style={{ fontWeight: 600, minWidth: 190, position: 'sticky', left: 308, zIndex: 5, backgroundColor: '#f8fafc' }}>Período</TableCell>
                  <TableCell align="left" style={{ fontWeight: 600, minWidth: 200 }}>Carrera</TableCell>
                  <TableCell align="left" style={{ fontWeight: 600, minWidth: 180 }}>Materia</TableCell>
                  <TableCell align="center" style={{ fontWeight: 600, minWidth: 80 }}>Curso</TableCell>
                  <TableCell align="center" style={{ fontWeight: 600, minWidth: 80 }}>Sem.</TableCell>
                  <TableCell align="center" style={{ fontWeight: 600, minWidth: 120 }}>Estado</TableCell>
                  <TableCell align="center" style={{ fontWeight: 600, minWidth: 90 }}>Alumnos</TableCell>
                  <TableCell align="center" style={{ fontWeight: 600, minWidth: 90 }}>Rectif.</TableCell>
                  <TableCell align="left" style={{ fontWeight: 600, minWidth: 130 }}>Envío</TableCell>
                  <TableCell align="left" style={{ fontWeight: 600, minWidth: 200 }}>Tutor</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={13} align="center" style={{ padding: '40px' }}>
                      <Typography variant="body2" color="textSecondary">
                        Cargando datos...
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : displayedRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={13} align="center" style={{ padding: '40px' }}>
                      <Typography variant="body2" color="textSecondary">
                        {searchTerm.trim() ?
                          'No se encontraron cronogramas que coincidan con la búsqueda' :
                          'No hay cronogramas disponibles'
                        }
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : displayedRows.map((row, index) => (
                  <TableRow
                    key={index}
                    style={{
                      '&:hover': { backgroundColor: '#f8f9fa' },
                      borderBottom: '1px solid #e9ecef'
                    }}
                  >
                    {/* 1. Selección */}
                    <TableCell padding="checkbox" style={{ position: 'sticky', left: 0, zIndex: 3, backgroundColor: 'white' }}>
                      <Checkbox
                        size="small"
                        color="primary"
                        checked={selectedCronogramas.includes(row.id)}
                        onChange={() => toggleRowSelection(row.id)}
                      />
                    </TableCell>

                    {/* 2. Acciones */}
                    <TableCell align="center" style={{ position: 'sticky', left: 48, zIndex: 3, backgroundColor: 'white' }}>
                      <Box display="flex" justifyContent="center" gap={1}>
                        {hasRole(Roles.ROLE_USER) &&
                          <>
                            {showEditButton(row) ?
                              <Tooltip title="Editar cronograma" arrow>
                                <IconButton
                                  size="small"
                                  className={classes.actionButton}
                                  onClick={() => history.push({
                                    pathname: `/convenios/cronogramasPracticas/editar/${params.convenioId}/${row.id}`,
                                    state: {
                                      edit: true
                                    }
                                  })}
                                  style={{
                                    backgroundColor: '#eff6ff',
                                    color: '#2563eb',
                                    border: '1px solid #dbeafe'
                                  }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            :
                              <Tooltip title="Ver cronograma" arrow>
                                <IconButton
                                  size="small"
                                  className={classes.actionButton}
                                  onClick={() => history.push({
                                    pathname: `/convenios/cronogramasPracticas/ver/${params.convenioId}/${row.id}`,
                                    state: {
                                      readOnly: true
                                    }
                                  })}
                                  style={{
                                    backgroundColor: '#f0fdf4',
                                    color: '#16a34a',
                                    border: '1px solid #dcfce7'
                                  }}
                                >
                                  <VisibilityIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                          }
                          </>
                        }

                        {hasAnyRole([Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]) &&
                          <>
                            <Tooltip title="Revisar cronograma" arrow>
                              <IconButton
                                size="small"
                                className={classes.actionButton}
                                onClick={() => history.push({
                                  pathname: `/convenios/cronogramasPracticas/ver/${params.convenioId}/${row.id}`,
                                  state: {
                                    readOnly: true,
                                    aprobar: row.estado === EstadosCronograma.PENDIENTE_APROBACION
                                            || row.estado === EstadosCronograma.PRACTICA_PENDIENTE_MODIFICACIONES_APROBACION
                                  }
                                })}
                                style={{
                                  backgroundColor: '#fef3c7',
                                  color: '#d97706',
                                  border: '1px solid #fed7aa'
                                }}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </>
                        }
                        <Tooltip title="Descargar cronograma" arrow>
                          <IconButton
                            size="small"
                            className={classes.actionButton}
                            onClick={() => downloadOne(row)}
                            style={{
                              backgroundColor: '#f8fafc',
                              color: '#475569',
                              border: '1px solid #e2e8f0'
                            }}
                          >
                            <GetAppIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>

                    {/* 2. Nro. Cronograma */}
                    <TableCell align="left" style={{ position: 'sticky', left: 188, zIndex: 3, backgroundColor: 'white' }}>
                      <Chip
                        label={row.id}
                        size="small"
                        variant="outlined"
                        style={{
                          backgroundColor: '#f0f9ff',
                          borderColor: '#0ea5e9',
                          color: '#0369a1',
                          fontSize: '0.75rem',
                          fontWeight: 500,
                          height: 24
                        }}
                      />
                    </TableCell>

                    {/* 3. Período */}
                    <TableCell align="left" style={{ position: 'sticky', left: 308, zIndex: 3, backgroundColor: 'white' }}>
                      <Box display="flex" flexWrap="wrap" style={{ gap: 6 }}>
                        <Chip
                          label={`Desde ${formatDate(row.fechaDesde)}`}
                          size="small"
                          style={{
                            backgroundColor: '#e8f0fe',
                            borderColor: '#c6dafc',
                            color: '#1967d2',
                            border: '1px solid',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            height: 24
                          }}
                        />
                        <Chip
                          label={`Hasta ${formatDate(row.fechaHasta)}`}
                          size="small"
                          style={{
                            backgroundColor: '#e6f4ea',
                            borderColor: '#b7e1cd',
                            color: '#137333',
                            border: '1px solid',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            height: 24
                          }}
                        />
                      </Box>
                    </TableCell>

                    {/* 4. Carrera */}
                    <TableCell align="left" style={{ maxWidth: 200 }}>
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        {row.carreraDescripcion}
                      </Typography>
                    </TableCell>

                    {/* 5. Materia */}
                    <TableCell align="left" style={{ maxWidth: 180 }}>
                      <Typography variant="body2">
                        {row.materia}
                      </Typography>
                    </TableCell>

                    {/* 6. Curso */}
                    <TableCell align="center">
                      <Chip
                        label={row.curso}
                        size="small"
                        variant="outlined"
                        style={{
                          backgroundColor: '#eff6ff',
                          borderColor: '#3b82f6',
                          color: '#1e40af',
                          fontWeight: 500
                        }}
                      />
                    </TableCell>

                    {/* 7. Semestre */}
                    <TableCell align="center">
                      <Chip
                        label={row.semestre}
                        size="small"
                        variant="outlined"
                        style={{
                          backgroundColor: '#f0fdf4',
                          borderColor: '#10b981',
                          color: '#047857',
                          fontWeight: 500
                        }}
                      />
                    </TableCell>

                    {/* 8. Estado */}
                    <TableCell align="center">
                      <Tooltip title={row.estado || ''} arrow>
                        <Chip
                          label={getShortStatus(row.estado)}
                          size="small"
                          className={classes.statusChip}
                          style={{
                            backgroundColor: getStatusColor(row.estado).bg,
                            color: getStatusColor(row.estado).text,
                            border: `1px solid ${getStatusColor(row.estado).border}`,
                            fontWeight: 500
                          }}
                        />
                      </Tooltip>
                    </TableCell>

                    {/* 9. Cantidad Alumnos */}
                    <TableCell align="center">
                      <Box display="flex" alignItems="center" justifyContent="center">
                        <Typography variant="body2" style={{ fontWeight: 600, color: '#374151' }}>
                          {row.cantidadAlumnos || 0}
                        </Typography>
                      </Box>
                    </TableCell>

                    {/* 10. Alumnos Rectificados */}
                    <TableCell align="center">
                      {(() => {
                        const cantidad = cronogramasRectificados[row.id] || 0;
                        return cantidad > 0 ? (
                          <Chip
                            icon={<AssignmentIcon style={{ color: '#e65100', fontSize: '16px' }} />}
                            label={cantidad}
                            size="small"
                            style={{
                              backgroundColor: '#fff3e0',
                              borderColor: '#ffcc80',
                              color: '#e65100',
                              fontWeight: 600,
                              border: '1px solid'
                            }}
                          />
                        ) : (
                          <Typography variant="body2" style={{ color: '#9ca3af' }}>
                            -
                          </Typography>
                        );
                      })()}
                    </TableCell>

                    {/* 11. Fecha de Envío */}
                    <TableCell align="left">
                      <Typography variant="body2" style={{ color: '#6b7280' }}>
                        {formatDate(row.fechaEnvio)}
                      </Typography>
                    </TableCell>

                    {/* 12. Tutor */}
                    <TableCell align="left" style={{ maxWidth: 200 }}>
                      {row.tutorPrincipal && row.tutorCedula ? (
                        <Box>
                          <Typography variant="body2" style={{ color: '#374151', marginBottom: 4 }}>
                            {row.tutorPrincipal}
                          </Typography>
                          <Chip
                            label={`C.I. ${row.tutorCedula}`}
                            size="small"
                            variant="outlined"
                            style={{
                              backgroundColor: '#f0fdf4',
                              borderColor: '#22c55e',
                              color: '#15803d',
                              fontSize: '0.75rem',
                              fontWeight: 500,
                              height: 22
                            }}
                          />
                        </Box>
                      ) : (
                        <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>Sin asignar</span>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    className={classes.paginationRight}
                    rowsPerPageOptions={[10, 15, 20, 25]}
                    colSpan={13}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "Registros por página" },
                      native: false,
                    }}
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} de ${count}${searchTerm.trim() ? ' (filtrados)' : ''}`
                    }
                    labelRowsPerPage="Registros por página"
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Paper>

        {/* Botón Atrás */}
        <Box mt={3} display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => history.push({
              pathname: `/convenios/editar/${params.convenioId}`,
            })}
            style={{
              borderColor: '#d1d5db',
              color: '#374151',
              backgroundColor: 'white',
              '&:hover': {
                borderColor: '#9ca3af',
                backgroundColor: '#f9fafb'
              }
            }}
          >
            ← Volver al Convenio
          </Button>
        </Box>

        {/* Botón flotante para agregar nuevo cronograma */}
        {hasRole(Roles.ROLE_USER) && (
          <Box position="fixed" bottom={24} right={24} zIndex={1000}>
            <Link to={`/convenios/cronogramasPracticas/crear/${params.convenioId}`}>
              <Fab
                color="primary"
                aria-label="nuevo"
                style={{
                  backgroundColor: '#3b82f6',
                  '&:hover': {
                    backgroundColor: '#2563eb'
                  }
                }}
              >
                <Tooltip title="Nuevo cronograma de práctica" arrow>
                  <AddIcon />
                </Tooltip>
              </Fab>
            </Link>
          </Box>
        )}

        {/* Diálogos */}
        <DeleteDialog
          open={openDialog}
          onClose={handleCloseDialog}
          onAccept={deleteOne}
          aria-labelledby="form-dialog-title"
        />

        <Modal
          open={modal}
          style={{outline: 'none'}}
          classes={{focused: classes.outlinedInputFocused}}
        >
          {bodyModal}
        </Modal>
      </Grid>
    </Grid>
  );
};

export default List;
